import request from "../request";
import Url from "../url/project";

const getProjectList = ({
  prefix = "",
  path = "",
  data,
  options = {},
} = {}) => {
  return request.get(prefix + Url.getProjectList + path, data, options);
};
const getProjectDetail = ({
  prefix = "",
  path = "",
  data,
  options = {},
} = {}) => {
  return request.get(prefix + Url.getProjectDetail + path, data, options);
};
const setProject = ({ prefix = "", path = "", data, options = {} } = {}) => {
  return request.post(prefix + Url.setProject + path, data, options);
};
const updateProject = ({ prefix = "", path = "", data, options = {} } = {}) => {
  return request.post(prefix + Url.updateProject + path, data, options);
};
const updateMultiProject = ({
  prefix = "",
  path = "",
  data,
  options = {},
} = {}) => {
  return request.post(prefix + Url.updateMultiProject + path, data, options);
};
const deleteProject = ({ prefix = "", path = "", data, options = {} } = {}) => {
  return request.post(prefix + Url.deleteProject + path, data, options);
};
const authOCT = ({ prefix = "", path = "", data, options = {} } = {}) => {
  return request.post(prefix + Url.authOCT + path, data, options, {
    responseSecret: false,
  });
};
const authVerify = ({
  prefix = "",
  path = "",
  data,
  options = {},
  settings = {},
} = {}) => {
  return request.post(prefix + Url.authVerify + path, data, options, settings);
};

export default {
  getProjectList,
  getProjectDetail,
  setProject,
  updateProject,
  updateMultiProject,
  deleteProject,
  authOCT,
  authVerify,
};
